import React, { useState } from "react";
import './process.css'; // Add styles here
import Step1 from '../../assets/step1.jpg';
import Step2 from '../../assets/step2.jpg';
import Step3 from '../../assets/step3.jpg';
import Step4 from '../../assets/step4.jpg';

const stepImages = [Step1, Step2, Step3, Step4];

function Process() {
    const [selectedImage, setSelectedImage] = useState(Step1);
    const [imageLoaded, setImageLoaded] = useState(true);

    const handleStepClick = (index) => {
        setImageLoaded(false);
        setTimeout(() => {
            setSelectedImage(stepImages[index]);
            setImageLoaded(true); 
        }, 200); 
    };

    return (
        <div className="process">
            <p className="component-name">How It Works?</p>
            <div className="component-head">
                <h2>Discover the Journey</h2>
                <p>Embark on an unforgettable adventure with our expertly curated travel experiences.</p>
            </div>
            <div className="process-container">
                <div className="process-image-container">
                    <img 
                        src={selectedImage} 
                        alt="Step" 
                        className={`process-image ${imageLoaded ? 'visible' : ''}`} 
                        onLoad={() => setImageLoaded(true)} // Ensure the fade-in happens after image loads
                    />
                </div>
                <div className="process-steps-container">
                    <h2 id="process-head">Click to know</h2>
                    <div className="process-step" onMouseEnter={() => handleStepClick(0)}>
                        <h3>Register Your Account</h3>
                        <p>Create a profile to start connecting with fellow travelers.</p>
                    </div>
                    <div className="process-step" onMouseEnter={() => handleStepClick(1)}>
                        <h3>Find Like-minded Friends</h3>
                        <p>Discover and connect with travelers who share your interests.</p>
                    </div>
                    <div className="process-step" onMouseEnter={() => handleStepClick(2)}>
                        <h3>Plan Your Trip</h3>
                        <p>Coordinate with your travel buddies to organize the perfect getaway.</p>
                    </div>
                    <div className="process-step" onMouseEnter={() => handleStepClick(3)}>
                        <h3>Explore Destinations</h3>
                        <p>Embark on your journey and explore new places with new friends.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Process;
